module.exports = __webpack_public_path__ + "static/media/coatOfArms.e56d4b00.svg";